export default __webpack_public_path__ + "apply7_144d967.png";